import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";

class TerminalService {
    getTerminals(){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/terminal/getTerminals' + '?merchant=' + user.merchant;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getTerminalsForLocation(locationId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/terminal/getTerminalsForLocation' + '?merchant=' + user.merchant + '&locationId=' + locationId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

updateTerminalProperties(documentId, newTerminalId, newDeviceName, useAsCloudPrinter, cloudPrinterChannels, cloudPrinterOrderTypes, kdsRole){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/terminal/updateTerminalProperties';
        let basicAuth = authHeader();
        let body = {
            merchant: user.merchant,
            id: documentId,
            newTerminalId: newTerminalId,
            newDeviceName: newDeviceName,
            useAsCloudPrinter: useAsCloudPrinter,
            cloudPrinterChannels: cloudPrinterChannels || [],
            cloudPrinterOrderTypes: cloudPrinterOrderTypes || []
        };
        // A kitchen display's role: sent only for a KDS. Left out, the server leaves the stored one as it is.
        if (kdsRole !== undefined) {
            body.kdsRole = kdsRole;
        }
        return axios.post(url, body, { headers: basicAuth });
    }

    /**
     * SUPER_ADMIN: hide a terminal from the merchant's own pages, or show it again. Visibility only — the terminal,
     * its journal and its device are untouched (CagistaServices terminal/HiddenTerminals).
     */
    setTerminalHidden(documentId, hide){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/superadmin/terminal/' + (hide ? 'hide' : 'show');
        let basicAuth = authHeader();
        return axios.post(url, {
            merchant: user.merchant,
            id: documentId
        }, { headers: basicAuth });
    }

    /**
     * Each of the merchant's terminals and what it last reported about Sync Gateway (CagistaServices
     * TerminalSyncStateService). ADMIN and SUPER_ADMIN; error details for SUPER_ADMIN only.
     */
    getTerminalSyncStates(){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/admin/terminalSyncStates' + '?merchant=' + encodeURIComponent(user.merchant);
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    forceResync(terminalDocumentId){
        let url = '/api/sync/forceResync';
        let basicAuth = authHeader();
        return axios.post(url, {
            terminalDocumentId: terminalDocumentId
        }, { headers: basicAuth });
    }

    migrateTerminal(fromTerminalId, toTerminalId, locationId, fromDate, toDate){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/terminal/migrateTerminal';
        let basicAuth = authHeader();
        return axios.post(url, {
            merchant: user.merchant,
            locationId: locationId,
            fromTerminalId: fromTerminalId,
            toTerminalId: toTerminalId,
            fromDate: fromDate,
            toDate: toDate
        }, { headers: basicAuth });
    }

}

export default new TerminalService();
